import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

interface ModalConfirmProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  content: string;
  titleComfirm: string;
  action: () => void;
}

const ModalConfirm: React.FC<ModalConfirmProps> = ({
  isOpen,
  onClose,
  title = "Xác nhận",
  content = "Bạn có chắc chắn muốn thực hiện thao tác này?",
  titleComfirm = "Xác nhận",
  action,
}) => {

  const { t } = useTranslation()
  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogTitle>
        {title}
        <hr className="my-2" />
      </DialogTitle>
      <DialogContent>
        <Typography>
          {content}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="inherit" variant="contained">
          {t('common.cancel')}
        </Button>
        <Button onClick={action} color="primary" variant="contained">
          {titleComfirm}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalConfirm;
